import React, {useEffect, useRef, useState} from 'react'
import {useSelector} from 'react-redux'
import {KTSVG} from '../../../../_metronic/helpers'
import {GetAnaVezneCustomerByExcell, UploadCustomersFromExcell} from '../apis/ApiCall'
import {RootState} from '../../../../setup'

type Props = {
  currentStore: {AnavezneKodu: string; AnavezneAdi: string}
}

const TableButtons: React.FC<Props> = ({currentStore}) => {
  const [fileName, setFileName] = useState<string>('')

  const searchedCustomers = useSelector((state: RootState) => state.customers.searchedCustomers)

  const uploadInput = useRef(null)

  const importProducts = async (file: any) => {
    if (file != null) {
      if ((file.name as string).includes('xls')) {
        var resp = await UploadCustomersFromExcell(file)
      }
    }
  }

  const handleFileUpload = (event: any) => {
    setFileName(event.target.files[0].name)

    setTimeout(() => {
      importProducts(event.target.files[0])
    }, 500)
  }

  const uploadButtonClicked = () => {
    ;(uploadInput.current as any).click()
  }

  const handleCustomerDownload = (e: any) => {
    e.preventDefault()
    let anavezneCustomers: any[] = []
    searchedCustomers.map((customer: any) => {
      let newCustomer = {
        MusteriAdi: 'İsim Bilgisi Yok',
        VkNo: 'Vergi No Bilgisi Yok',
        AnavezneKodu: 'Mağaza Bilgisi Yok',
        AnavezneAdi: 'Mağaza Bilgisi Yok',
        Kodu: 'Kod Bilgisi Yok',
      }

      newCustomer.MusteriAdi = customer.CustName !== null ? customer.CustName : 'İsim Bilgisi Yok'
      newCustomer.VkNo = customer.VergiNo !== null ? customer.VergiNo : 'Vergi No Bilgisi Yok'
      newCustomer.AnavezneKodu =
        customer.StoreId !== null ? customer.StoreId.toString() : 'Mağaza Bilgisi Yok'
      newCustomer.AnavezneAdi =
        customer.StoreDesc !== null ? customer.StoreDesc : 'Mağaza Bilgisi Yok'
      newCustomer.Kodu =
        customer.Customerreference !== null ? customer.Customerreference : 'Kod Bilgisi Yok'

      anavezneCustomers.push(newCustomer)
    })
    GetAnaVezneCustomerByExcell(anavezneCustomers)
  }

  return (
    <>
      <div className='d-flex '>
        <div className='m-2'>
          <button className='btn btn-success' onClick={(e) => handleCustomerDownload(e)}>
            <KTSVG
              path='/media/icons/duotune/files/fil017.svg'
              className='svg-icon-muted svg-icon-2hx'
            />
            <span>Müşterileri İndir</span>
          </button>
        </div>
        <div className='m-2'>
          <input type='file' hidden ref={uploadInput} onChange={handleFileUpload} />
          <button className='btn btn-primary' onClick={uploadButtonClicked}>
            <KTSVG
              path='/media/icons/duotune/files/fil018.svg'
              className='svg-icon-muted svg-icon-2hx'
            />
            <span>Müşterileri Yükle</span>
          </button>
        </div>
      </div>
    </>
  )
}

export default TableButtons
